export default __webpack_public_path__ + "22c6a41854b98ba3b63b897d5481c257.svg";